import _awaitAsyncGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/awaitAsyncGenerator.js";
import _wrapAsyncGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/wrapAsyncGenerator.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, "return": function _return(r) { var n = this.s["return"]; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, "throw": function _throw(r) { var n = this.s["return"]; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
/**
 * SSE decoding over `fetch` + `ReadableStream`.
 *
 * Not `EventSource`, which would be the obvious choice, because it cannot POST,
 * cannot set headers, and cannot be given a credentials mode. This transport
 * needs all three, so the parse loop is ours.
 *
 * The wire format is where this goes wrong if written casually. Frames are
 * separated by a blank line; a single frame may carry several `data:` lines
 * that join with newlines; and a network chunk can end anywhere at all,
 * including mid-frame or halfway through a UTF-8 sequence. `TextDecoderStream`
 * handles the multi-byte characters, and the buffering below handles the rest.
 */

/**
 * Split a raw SSE body into frame payloads, i.e. the joined `data:` lines of
 * each frame. Yields as soon as a frame completes rather than buffering the
 * whole response, which is the entire point of streaming.
 */
export function readSSE(_x, _x2) {
  return _readSSE.apply(this, arguments);
}

/**
 * Extract the data payload from one frame, or null if it has none.
 *
 * Comment lines (`: keep-alive`) and the other SSE fields (`event:`, `id:`,
 * `retry:`) are ignored: orqestrator carries everything the client needs inside
 * the JSON, so the field-level metadata is noise here.
 */
function _readSSE() {
  _readSSE = _wrapAsyncGenerator(/*#__PURE__*/_regenerator().m(function _callee(body, signal) {
    var reader, buffer, _yield$_awaitAsyncGen, done, value, idx, frame, payload, tail;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          // TextDecoderStream keeps a partial multi-byte character across reads, so a
          // chunk boundary inside a UTF-8 sequence does not corrupt the text.
          reader = body.pipeThrough(new TextDecoderStream()).getReader();
          buffer = "";
          _context.p = 1;
        case 2:
          if (!(signal !== null && signal !== void 0 && signal.aborted)) {
            _context.n = 3;
            break;
          }
          return _context.a(2);
        case 3:
          _context.n = 4;
          return _awaitAsyncGenerator(reader.read());
        case 4:
          _yield$_awaitAsyncGen = _context.v;
          done = _yield$_awaitAsyncGen.done;
          value = _yield$_awaitAsyncGen.value;
          if (!done) {
            _context.n = 5;
            break;
          }
          return _context.a(3, 9);
        case 5:
          buffer += value;

          // Normalise first: \r\n\r\n is a legal frame separator too, and mixing
          // the two makes the indexOf below unreliable.
          buffer = buffer.replace(/\r\n/g, "\n");
          idx = void 0; // A single chunk can contain several complete frames, so drain rather
          // than handling one and waiting for the next read.
        case 6:
          if (!((idx = buffer.indexOf("\n\n")) !== -1)) {
            _context.n = 8;
            break;
          }
          frame = buffer.slice(0, idx);
          buffer = buffer.slice(idx + 2);
          payload = frameData(frame);
          if (!(payload !== null)) {
            _context.n = 7;
            break;
          }
          _context.n = 7;
          return payload;
        case 7:
          _context.n = 6;
          break;
        case 8:
          _context.n = 2;
          break;
        case 9:
          // A well-behaved server ends with a blank line. If the connection closes
          // on a complete frame without one, the frame is still real, so do not
          // silently drop the last message.
          tail = frameData(buffer.replace(/\r\n/g, "\n"));
          if (!(tail !== null)) {
            _context.n = 10;
            break;
          }
          _context.n = 10;
          return tail;
        case 10:
          _context.p = 10;
          reader.releaseLock();
          return _context.f(10);
        case 11:
          return _context.a(2);
      }
    }, _callee, null, [[1,, 10, 11]]);
  }));
  return _readSSE.apply(this, arguments);
}
function frameData(frame) {
  var data = [];
  var _iterator2 = _createForOfIteratorHelper(frame.split("\n")),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var line = _step2.value;
      if (line.startsWith(":")) continue; // keep-alive comment
      if (!line.startsWith("data:")) continue;
      // Exactly one optional leading space is stripped, per the spec. Stripping
      // more would corrupt payloads that legitimately begin with whitespace.
      var value = line.slice(5);
      if (value.startsWith(" ")) value = value.slice(1);
      data.push(value);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  if (data.length === 0) return null;
  var joined = data.join("\n");
  // Some SSE producers close with a [DONE] sentinel. orqestrator does not, but
  // treating it as end-of-data costs nothing and avoids a JSON parse error if a
  // proxy ever inserts one.
  return joined === "[DONE]" ? null : joined;
}

/**
 * Decode frames into JSON objects.
 *
 * A malformed frame is reported and skipped rather than thrown: the rest of the
 * stream is still useful, and killing an entire agent run over one bad frame
 * would turn a cosmetic problem into a failed request.
 */
export function readJSONEvents(_x3, _x4, _x5) {
  return _readJSONEvents.apply(this, arguments);
}
function _readJSONEvents() {
  _readJSONEvents = _wrapAsyncGenerator(/*#__PURE__*/_regenerator().m(function _callee2(body, signal, onMalformed) {
    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, raw, _t, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _iteratorAbruptCompletion = false;
          _didIteratorError = false;
          _context2.p = 1;
          _iterator = _asyncIterator(readSSE(body, signal));
        case 2:
          _context2.n = 3;
          return _awaitAsyncGenerator(_iterator.next());
        case 3:
          if (!(_iteratorAbruptCompletion = !(_step = _context2.v).done)) {
            _context2.n = 8;
            break;
          }
          raw = _step.value;
          _context2.p = 4;
          _context2.n = 5;
          return JSON.parse(raw);
        case 5:
          _context2.n = 7;
          break;
        case 6:
          _context2.p = 6;
          _t = _context2.v;
          onMalformed === null || onMalformed === void 0 || onMalformed(raw, _t);
        case 7:
          _iteratorAbruptCompletion = false;
          _context2.n = 2;
          break;
        case 8:
          _context2.n = 10;
          break;
        case 9:
          _context2.p = 9;
          _t2 = _context2.v;
          _didIteratorError = true;
          _iteratorError = _t2;
        case 10:
          _context2.p = 10;
          _context2.p = 11;
          if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) {
            _context2.n = 12;
            break;
          }
          _context2.n = 12;
          return _awaitAsyncGenerator(_iterator["return"]());
        case 12:
          _context2.p = 12;
          if (!_didIteratorError) {
            _context2.n = 13;
            break;
          }
          throw _iteratorError;
        case 13:
          return _context2.f(12);
        case 14:
          return _context2.f(10);
        case 15:
          return _context2.a(2);
      }
    }, _callee2, null, [[11,, 12, 14], [4, 6], [1, 9, 10, 15]]);
  }));
  return _readJSONEvents.apply(this, arguments);
}